import styled from 'styled-components';

const outerCircleSize = '120';
const innerCircleSize = '108';
const transitionLength = '1s';
const svgDash = 358;

export const ProgressMeterCircle = styled.div<{
	noData: boolean;
	children?: any;
	daysLeftPercent: string | number;
	shouldAnimateDaysLeft?: boolean;
}>`
	margin: 0 auto;
	width: ${outerCircleSize}px;
	height: ${outerCircleSize}px;
	position: relative;

	@keyframes anim {
		100% {
			stroke-dashoffset: ${(props: any) => !props.noData ? svgDash - (svgDash * Number(props.daysLeftPercent)) : svgDash};
		}
	}

	svg {
		position: absolute;
		top: 0;
		left: 0;
		transform: rotate(-90deg);

		circle {
			fill: none;
			stroke: ${(props: any) => !props.noData ? `var(--cvna-color-green-2)` : `#e4ecf0`};
			stroke-width: 6px;
			stroke-dasharray: ${svgDash};
			stroke-dashoffset: 0;
			animation: ${props => props.shouldAnimateDaysLeft ? `anim ${transitionLength} linear forwards` : 'none'};
		}
	}
`;

export const OuterCircle = styled.div<{
	noData: boolean;
}>`
	width: ${outerCircleSize}px;
	height: ${outerCircleSize}px;
	padding: 6px;
	background-color: ${props => !props.noData ? `var(--cvna-color-grey-2)` : '#e4ecf0'};
	border-radius: 50%;
`;

export const InnerCircle = styled.div`
	width: 	${innerCircleSize}px;
	height: ${innerCircleSize}px;
	background-color: var(--cvna-color-white);
	border-radius: 50%;
`;

export const ProgressText = styled.div<{
	hasMaxMilage: boolean;
}>`
	position: absolute;
	top: ${props => props.hasMaxMilage ? '10px' : '20px'};
	left: 19px;
	width: 80px;
	height: 80px;
	font-size: ${props => props.hasMaxMilage ? '9px' : '12px'};;
	line-height: ${props => props.hasMaxMilage ? '14px' : '16px'};
	font-weight: 400;
	text-align: center;
	color: #6d7184;

	p {
		margin: 0;
	}
`;

export const TimeRemaining = styled.h3`
	margin: 0;
	font-size: 40px;
	line-height: 44px;
	font-weight: 700;
	color: var(--cvna-color-blue-6);
`;

export const DataNotAvailable = styled.div`
	position: relative;
	top: 18px;
	line-height: 14px;

	@media (min-width: ${(props) => props.theme.breakpoint.md}px) {
		top: 22px;
		line-height: 18px;
	}
`;

export const Loading = styled.div`
	position: relative;
	top: 25px;
	line-height: 14px;

	@media (min-width: ${(props) => props.theme.breakpoint.md}px) {
		top: 31px;
		line-height: 18px;
	}
`;